import { render } from "./InputRequiredText.vue?vue&type=template&id=57d793a2&scoped=true"
import script from "./InputRequiredText.vue?vue&type=script&lang=js"
export * from "./InputRequiredText.vue?vue&type=script&lang=js"

import "./InputRequiredText.vue?vue&type=style&index=0&id=57d793a2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3368519796/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d793a2"]])

export default __exports__